import getFormattedSubscriptionPrice from './get-formatted-subscription-price';

export default {
  getFormattedSubscriptionPrice,
};
